import { presentViteEnvVars, type ViteEnvDisplay } from './settingsDisplay';

type ViteEnvPanelProps = {
  rows?: ViteEnvDisplay[];
  env?: {
    VITE_API_BASE?: unknown;
    VITE_CP_BASE?: unknown;
    VITE_CDN_BASE?: unknown;
  };
};

export function ViteEnvPanel({ rows, env }: ViteEnvPanelProps) {
  const displayed = rows ?? presentViteEnvVars(env ?? {});
  return (
    <div className="grid sm:grid-cols-3 gap-3 text-sm">
      {displayed.map((row) => (
        <div key={row.name} data-testid={`vite-env-${row.name}`}>
          <div className="text-xs text-gray-500">{row.name}</div>
          <div className="font-mono break-all" data-testid={`vite-env-${row.name}-value`}>
            {row.display}
          </div>
          <div className="text-xs text-gray-500">{row.note}</div>
        </div>
      ))}
    </div>
  );
}
